import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var markIsDevicesDirty = mutatorAction('markIsDevicesDirty', function (isDirty) {
    var store = mobileDeviceFullStore();
    store.isDevicesDirty = isDirty;
});
//# sourceMappingURL=markIsDevicesDirty.js.map